var PAY = {};
var _certValidData = {
    certType: true,
    name: false,
    identity: false,
    wechat: false,
    email: false,
    company: false,
    job: false,
    charge: false,
    picHash: false,
    hash: false
};
PAY._token = $.jStorage.get("localToken");

PAY.init = function () {
    // PAY.getSuiteList(PAY.setPage);
    showLoadingGif();
    Promise.all([this.getUserStatus(), PAY.getSuiteList(), PAY.getSelectIdentity()]).then((result) => {
        closeLoadingGif();
        PAY.setPage(result)
    })
    // 是否需要发票
    _certValidData.checkbox = false;
}

PAY.initForTry = function () {
    PAY.getSuiteList(PAY.setTryPage);
    showLoadingGif();
    Promise.all([this.getUserStatus(), PAY.getSuiteList(), PAY.getSelectIdentity()]).then((result) => {
        closeLoadingGif();
        PAY.setTryPage(result)
    })
}

PAY.getSelectIdentity = () => {
    let getRequest = new Promise((resolve, reject) => {
        $.get({
            url: v1url + 'cert/identity',
            headers: {
                "devicetoken": cookie_PENCILNEWSID,
                "token": PAY._token
            },
            success: (data) => {
                // console.log(data)
                if (data.code === 1000) {
                    resolve(data.data);
                } else if (data.code == -1) {
                    UTL.showPCLoginForm();
                } else {
                    toastr.error(data.message);
                }
            },
            error: (err) => {
                console.log(err)
                reject(err);
            }
        });
    });
    return getRequest;
}

PAY.getSuiteList = () => {
    // console.log(callback)
    // showLoadingGif();
    let getRequest = new Promise((resolve, reject) => {
        $.ajax({
            url: v1url + "buy/suite-list",
            type: "GET",
            headers: {
                devicetoken: cookie_PENCILNEWSID,
                token: PAY._token
            },
            dataType: "json",
            success: (data) => {
                if (data.code == 1000) {
                    //   console.log(data)
                    PAY.suiteList = data.data.content;
                    // console.log(PAY.suiteList)
                    // PAY.getUserStatus(callback)
                    resolve(PAY.suiteList)
                } else if (data.code == -1) {
                    UTL.showPCLoginForm();
                } else {
                    toastr.error(data.message);
                }
            },
            error: (err) => {
                reject(err);
            }
        });
    });
    return getRequest;
}

PAY.getUserStatus = () => {
    // console.log(callback)
    let getRequest = new Promise((resolve, reject) => {
        $.ajax({
            url: v1url + "public/status",
            type: "GET",
            headers: {
                devicetoken: cookie_PENCILNEWSID,
                token: PAY._token
            },
            dataType: "json",
            success: (data) => {
                if (data.code == 1000) {
                    //   console.log(data)
                    PAY.userStatus = data.data.content;
                    // console.log(PAY.userStatus)
                    // callback(PAY.userStatus, PAY.suiteList)
                    resolve(PAY.userStatus)
                } else if (data.code == -1) {
                    UTL.showPCLoginForm();
                } else {
                    toastr.error(data.message);
                }
                // closeLoadingGif();
            },
            error: (err) => {
                reject(err);
            }
        });
    });
    return getRequest;
}

PAY.getBase64 = function (img, cb) {
    showLoadingGif()
    // 图片文件转base64
    var dataURL = "";
    img.onload = function () {
        //要先确保图片完整获取到，这是个异步事件
        var canvas = document.createElement("canvas"), //创建canvas元素
            imgSize = UTL.getImgSize(img); //确保canvas的尺寸和图片一样
        canvas.width = imgSize.width;
        canvas.height = imgSize.height;
        canvas.getContext("2d").drawImage(img, 0, 0, imgSize.width, imgSize.height); //将图片绘制到canvas中
        dataURL = canvas.toDataURL(); //转换图片为dataURL
        dataURL = dataURL.split("base64,")[1];
        cb && cb(dataURL);
    };
}

PAY.uploadAvatar = function (key, cropedImgBase64, datas, cb) {
    var uptoken3, upkey3;
    //Fsize: 文件大小，必选。支持传入 -1 表示文件大小以 http request body 为准。
    var url3 = "https://up-z1.qbox.me/putb64/-1";
    $.ajax({
        url: v1url + "uploader/uptoken",
        type: "GET",
        data: datas,
        headers: {
            token: $.jStorage.get("localToken"),
            devicetoken: cookie_PENCILNEWSID
        },
        success: function (data) {
            if (data.code == -1) {
                reLoginOnUc();
                return;
            } else if (data.code == 1000) {
                uptoken3 = data.data.uptoken;
                uptoken3 = "UpToken " + uptoken3;
                upkey3 = data.data.key;
                url3 += "/key/" + BASE64.encoder(upkey3);
                if (cropedImgBase64 != undefined) {
                    cb && cb(key, cropedImgBase64, url3, uptoken3);
                }
            } else {
                showWarning(data.message);
            }
        }
    });
}

PAY.putb64Jq = function (key, mypic, myurl, mytoken) {
    $.ajax({
        url: myurl,
        type: "POST",
        headers: {
            "Content-Type": "application/octet-stream",
            Authorization: mytoken,
            devicetoken: cookie_PENCILNEWSID
        },
        data: mypic,
        success: function (data) {
            $(key + " #upload_preview").attr("data-id", data.key);
            _certValidData.picHash = true;
            closeLoadingGif();
        }
    });
}

PAY.setPage = (result) => {
    let data = result[0];
    let data2 = result[1];
    let select_identity = result[2].identity;
    // console.log("dddd:",data,data2)
    var _html = ``;
    _html += `
    
    <div class="container pay_box">
        <div class="pay_head">
            <p>付费购买VIP账号</p>
        </div>

        ${data.is_investor == -1 ?
            `<div class="pay_step">
                <table>
                    <tr>
                        <td class="active">
                            <span class="sp1">
                                <span class="sp2">
                                    <span class="sp3"></span> 
                                </span> 
                            </span>
                            <p>投资人认证</p>
                        </td>
                        <td>
                            <div class="line"></div>
                            <span class="sp1">
                                <span class="sp2">
                                    <span class="sp3"></span> 
                                </span>
                            </span>
                            <p>选择开通时间</p>
                        </td>
                        <td>
                            <div class="line"></div>
                            <span class="sp1">
                                <span class="sp2">
                                    <span class="sp3"></span> 
                                </span>
                            </span>
                            <p>付款</p>
                        </td>
                        <td>
                            <div class="line"></div>
                            <span class="sp1">
                                <span class="sp2">
                                    <span class="sp3"></span> 
                                </span>
                            </span>
                            <p>等待审核</p>
                        </td>
                    </tr>
                </table>
            </div>`
        : ""}
        ${data.is_investor == -1 ? 
            `<div>
            <div class="pay_certified">
                <div class="certified_head">
                    第一步：投资人认证
                    <span>（以下信息都为必填项）</span>
                </div>
                <div class="certified_point"></div>
                <div class="certified_form">
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/investor_name.png" alt="???" />
                        <label>真实姓名：</label>
                        <input class="inputs" id="certified_name" type="text" name="name" placeholder="请填写您的真实姓名">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input none-border">
                        <img class="icon" src="/imgs/pay/pay_detail/identity.png" alt="???" />
                        <label>我的身份：</label>
                        <div class="identity-select">
                            <select id="certIdentity_select" class="js-states form-control select-style" aria-placeholder="请选择您的身份">
                                <option index='0' identity_id='' style='color: #c2c2c2' disabled selected>请选择身份</option>
                                ${select_identity && select_identity.length > 0 ? select_identity.map((item, ind) => {
                                    return `<option index=${ind+1} identity_id=${item.key} identity_name=${item.val}>${item.val}</option>`
                                }).join('') : ''}
                            </select>
                        </div>
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/compony.png" alt="???" />
                        <label>所在公司：</label>
                        <input class="inputs" id="certified_compony" type="text" name="company" placeholder="请填写所在公司名称">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/position.png" alt="???" />
                        <label>公司职位：</label>
                        <input class="inputs" id="certified_position" type="text" name="position" placeholder="请填写所在公司职位">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/email.png" alt="???" />
                        <label>电子邮箱：</label>
                        <input class="inputs" id="certified_email" type="email" name="email" placeholder="请填写您的电子邮箱">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input file">
                        <img class="icon" src="/imgs/pay/pay_detail/card.png" alt="???" />
                        <label>名片照片：</label>
                        <div class="card_file">
                            <div class="file_style" id="card-preview">
                                <img src="/imgs/pay/pay_detail/add_file.png" class="img-add" widht="34px" height="34px" alt="">
                                <p>点击上传</p>
                                <input id="upload_hide" type="file" name="file" accept="image/png,image/jpeg">
                                <img src="" id="upload_preview">
                            </div>
                            <ul class="file_prompt">
                                <li>上传图片结束后再提交信息</li>
                                <li>名片拍摄完整，不出现缺角</li>
                                <li>各项信息清晰可见，容易识别</li>
                                <li>证件必须真实拍摄，不能使用复印件</li>
                                <li>图片中无反光，无遮挡，无水印</li>
                                <li>图片大小不超过2M</li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="certified_btn certified_btn_pay">
                    <button type="button">下一步</button>
                </div>
            </div>

            <!--选择套餐组件  -->
            <div id="pay_content" style="display:none;">
                <div class="pay_content" >
                    <p>第二步：选择您需要开通的时间</p>
                    <div class="pay_time">
                    <div class="point"></div>
                        ${data2 && data2.length>0 ? data2.map((val)=>{
                            return `<li  data-id='${val.id}'>
                                        <div class="box">
                                            <div class="one">
                                                <span class="sp1">
                                                    ${val.date_limit}
                                                </span>
                                                <span class="sp2">省${ val.original_price - val.price }</span>
                                            </div>
                                            <p>¥${ val.price }</p>
                                            <div class="two">
                                                ¥${ val.original_price }
                                            </div>
                                        </div>
                                </li>`
                        }).join(""):""}
                    </div>
                </div>
                <!--发票信息组件  -->
                <div class="pay_form">
                    <div class="form-head">
                        <div id="checkbox_id" data-checked="false"><img class="icon" src="/imgs/pay/pay_detail/check_yes.png" alt=""></div> 需要发票 <span>（以下信息都为必填项）</span>
                    </div>
                    <div class="form-content">
                        <div class="hint">注：请您核对发票信息是否有误，提交之后，我们将根据您备注的信息打印发票，并且不再接受修改和调整，感谢您的理解与支持。</div>
                        <div class="form-input">
                            <label>发票抬头：</label>
                            <input class="inputs" id="billname" type="text" name="" placeholder="请填写个人／公司完整名称">
                            <img class="icon" src=""  alt="">
                        </div>
                        <div class="form-input">
                            <label>公司税号：</label>
                            <input class="inputs" id="billnumber" type="text" name="" placeholder="统一社会信用代码／纳税人识别号">
                            <img class="icon" src=""  alt="">
                        </div>
                        <div class="form-input">
                            <label>邮寄地址：</label>
                            <input class="inputs" id="billaddress" type="text" name="" placeholder="请输入您想要收到发票的地址">
                            <img class="icon" src=""  alt="">
                        </div>
                        <div class="form-input">
                            <label>收件人  &nbsp;&nbsp;：</label>
                            <input class="inputs" id="billpeople" type="text" name="" placeholder="请输入收件人的姓名">
                            <img class="icon" src=""  alt="">
                        </div>
                        <div class="form-input">
                            <label>联系电话：</label>
                            <input class="inputs" id="billphone" type="tel" name="" placeholder="请输入收件人的联系电话">
                            <img class="icon" src=""  alt="">
                        </div>
                    </div>
                </div>
                <div class="pay_footer">
                    <button class="btn1" type="button">上一步</button>
                    <button class="btn2" id="pc_pay" type="button">立即购买</button>
                </div>
            </div>

            <!--等待审核组件  -->
            <div class="pay_wait">
                <img src="/imgs/pay/pay_detail/wait_icon.jpg" class="wait_img" alt="">
                <p class="wait_tishi">您提交的信息会在24H之内进行审核，审核结果会以短信或者邮件的方式通知您～感谢您的支持</p>
            </div>
            </div>`
        :
        `<div>
            <!--选择套餐组件  -->
            <div class="pay_content">
                <p>选择您需要开通的时间</p>
                <div class="pay_time">
                <div class="point"></div>
                ${data2 && data2.length>0 ? data2.map((val)=>{
                            return `<li  data-id='${val.id}'>
                                        <div class="box">
                                            <div class="one">
                                                <span class="sp1">
                                                    ${val.date_limit}
                                                </span>
                                                <span class="sp2">省${ val.original_price - val.price }</span>
                                            </div>
                                            <p>¥${ val.price }</p>
                                            <div class="two">
                                                ¥${ val.original_price }
                                            </div>
                                        </div>
                                </li>`
                        }).join(""):""}
                </div>
            </div>

            <!--发票信息组件  -->
            <div class="pay_form">
                <div class="form-head">
                    <div id="checkbox_id" data-checked="false"><img src="/imgs/pay/pay_detail/check_yes.png" alt=""></div> 需要发票 <span>（以下信息都为必填项）</span>
                </div>
                <div class="form-content">
                    <div class="hint">注：请您核对发票信息是否有误，提交之后，我们将根据您备注的信息打印发票，并且不再接受修改和调整，感谢您的理解与支持。</div>
                    <div class="form-input">
                        <label>发票抬头：</label>
                        <input class="inputs" id="billname" type="text" name="" placeholder="请填写个人／公司完整名称">
                        <img class="icon" src=""  alt="">
                    </div>
                    <div class="form-input">
                        <label>公司税号：</label>
                        <input class="inputs" id="billnumber" type="text" name="" placeholder="统一社会信用代码／纳税人识别号">
                        <img class="icon" src=""  alt="">
                    </div>
                    <div class="form-input">
                        <label>邮寄地址：</label>
                        <input class="inputs" id="billaddress" type="text" name="" placeholder="请输入您想要收到发票的地址">
                        <img class="icon" src=""  alt="">
                    </div>
                    <div class="form-input">
                        <label>收件人  &nbsp;&nbsp;：</label>
                        <input class="inputs" id="billpeople" type="text" name="" placeholder="请输入收件人的姓名">
                        <img class="icon" src=""  alt="">
                    </div>
                    <div class="form-input">
                        <label>联系电话：</label>
                        <input class="inputs" id="billphone" type="tel" name="" placeholder="请输入收件人的联系电话">
                        <img class="icon" src=""  alt="">
                    </div>
                </div>
            </div>
            <div class="pay_footer">
                <button class="btn1" type="button"><a href="/projectlist">我再想想</a></button>
                <button class="btn2" id="pc_pay2" type="button">立即购买</button>
            </div>
        </div>`
        }
    </div>
    `
    $("#myPayPage").append(_html);
    inputsrequired();
    // 上传名片
    $(".certified_form .file .card_file input[type='file']").change(function () {
        var imgSrc;
        var cropedImgBase64;
        var selectId = $(this).attr("id");
        var f = document.getElementById(selectId).files[0];
        // console.log(f.size);
        if (f.size > 1024 * 1024 * 2) {
            showWarning("图片大小不得超过2M！");
            return;
        }
        imgSrc = window.URL.createObjectURL(f);
        $(".certified_form .file .card_file #upload_preview").attr("src", imgSrc);
        $(".certified_form .file .card_file #upload_preview").show();
        $("#card-preview").removeClass("checked_failed_input");
        PAY.getBase64($(".certified_form .file .card_file #upload_preview")[0], function (
            data_cropedImgBase64
        ) {
            PAY.uploadAvatar(
                ".card_file",
                data_cropedImgBase64, {
                    uptype: "4",
                    ext: "jpg"
                },
                PAY.putb64Jq
            );
        });
    });

    // 是否需要发票
    _certValidData.checkbox = false;
    $(".form-head").on("click", function (e) {
        $(".form-head span").toggle();
        $(".form-content").toggle();
        $("#checkbox_id img").toggle();
        _certValidData.checkbox = !_certValidData.checkbox;
        // console.log(_certValidData.checkbox);

    });
    // 套餐选择
    $(".pay_time li").on("click", function (e) {
        $(".pay_time li").removeAttr("class", "active");
        this.setAttribute("class", "active");
        // console.log($(".pay_time .active").attr("data-id"));
    });
}

PAY.setTryPage = (result) => {
    let data = result[0];
    let data2 = result[1];
    let select_identity = result[2].identity;
    //  console.log("dddd:",data,data2)
    var _html = ``;
    _html += `
    <div class="container pay_box">

        <div class="pay_head">
            <p>申请试用VIP账号</p>
            <div class="head_tishi">说明：铅笔道DATA服务目前只针对投资人开放哦～如果您不是投资人的话可能没办法通过审核的哦</div>
        </div>

        <div class="try_out">
            ${data.is_investor == 1 ?`<div>
                <div class="tryout_thishi">
                    <p>您已通过了投资人认证，点击“快速申请”即可试用一天VIP哦！</p>
                </div>
                <div class="certified_btn2">
                    <button type="button"><a href="/projectlist">取消申请</a></button>
                    <button id="pc_try2" type="button">快速申请</button>
                </div>
            </div>`:`${data.is_investor == -1 ? `<div>
                <div class="certified_head">
                    第一步：投资人认证
                    <span>（以下信息都为必填项）</span>
                </div>
                <div class="certified_point"></div>
                <div class="certified_form">
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/investor_name.png" alt="???" />
                        <label>真实姓名：</label>
                        <input class="inputs" id="certified_name" type="text" name="name" placeholder="请填写您的真实姓名">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input none-border">
                        <img class="icon" src="/imgs/pay/pay_detail/identity.png" alt="???" />
                        <label>我的身份：</label>
                        <div class="identity-select">
                            <select id="certIdentity_select" class="js-states form-control select-style" aria-placeholder="请选择您的身份">
                                <option index='0' identity_id='' style='color: #c2c2c2' disabled selected>请选择身份</option>
                                ${select_identity && select_identity.length > 0 ? select_identity.map((item, ind) => {
                                    return `<option index=${ind+1} identity_id=${item.key} identity_name=${item.val}>${item.val}</option>`
                                }).join('') : ''}
                            </select>
                        </div>
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/compony.png" alt="???" />
                        <label>所在公司：</label>
                        <input class="inputs" id="certified_compony" type="text" name="company" placeholder="请填写所在公司名称">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/position.png" alt="???" />
                        <label>公司职位：</label>
                        <input class="inputs" id="certified_position" type="text" name="position" placeholder="请填写所在公司职位">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input">
                        <img class="icon" src="/imgs/pay/pay_detail/email.png" alt="???" />
                        <label>电子邮箱：</label>
                        <input class="inputs" id="certified_email" type="email" name="email" placeholder="请填写您的电子邮箱">
                        <img class="icon" src="" alt="">
                    </div>
                    <div class="form-input file">
                        <img class="icon" src="/imgs/pay/pay_detail/card.png" alt="???" />
                        <label>名片照片：</label>
                        <div class="card_file">
                            <div class="file_style" id="card-preview">
                                <img src="/imgs/pay/pay_detail/add_file.png" widht="34px" height="34px" alt="">
                                <p>点击上传</p>
                                <input id="upload_hide" type="file" name="file" accept="image/png,image/jpeg">
                                <img src="" id="upload_preview">
                            </div>
                            <ul class="file_prompt">
                                <li>上传图片结束后再提交信息</li>
                                <li>名片拍摄完整，不出现缺角</li>
                                <li>各项信息清晰可见，容易识别</li>
                                <li>证件必须真实拍摄，不能使用复印件</li>
                                <li>图片中无反光，无遮挡，无水印</li>
                                <li>图片大小不超过2M</li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="certified_btn">
                    <button type="button"><a href="/projectlist">取消申请</a></button>
                    <button id="pc_try" type="button">快速申请</button>
                </div>
            </div>`:`<div>
                <div class="tryout_thishi">
                    <p>您提交的信息会在24H之内进行审核，审核结果会以短信或者邮件的方式通知您～感谢您的支持</p>
                </div>
                <div class="certified_btn2">
                    <button id="pc_try3" type="button"><a href="/projectlist">去首页</a></button>
                </div>
            </div>`}`}
            
        </div>

    </div>
    `

    $("#myTryPage").append(_html);
    inputsrequired();
    // 上传名片
    $(".certified_form .file .card_file input[type='file']").change(function () {
        var imgSrc;
        var cropedImgBase64;
        var selectId = $(this).attr("id");
        var f = document.getElementById(selectId).files[0];
        if (f.size > 1024 * 1024 * 2) {
            showWarning("图片大小不得超过2M！");
            return;
        }
        imgSrc = window.URL.createObjectURL(f);
        $(".certified_form .file .card_file #upload_preview").attr("src", imgSrc);
        $(".certified_form .file .card_file #upload_preview").show();
        $("#card-preview").removeClass("checked_failed_input");
        PAY.getBase64($(".certified_form .file .card_file #upload_preview")[0], function (
            data_cropedImgBase64
        ) {
            PAY.uploadAvatar(
                ".card_file",
                data_cropedImgBase64, {
                    uptype: "4",
                    ext: "jpg"
                },
                PAY.putb64Jq
            );
        });
    });
    // 是否需要发票
    _certValidData.checkbox = false;
    $(".form-head").on("click", function (e) {
        $(".form-head span").toggle();
        $(".form-content").toggle();
        $("#checkbox_id img").toggle();
        _certValidData.checkbox = !_certValidData.checkbox;
        // console.log(_certValidData.checkbox);

    });
    // 套餐选择
    $(".pay_time li").on("click", function (e) {
        $(".pay_time li").removeAttr("class", "active");
        this.setAttribute("class", "active");
        // console.log($(".pay_time .active").attr("data-id"));
    });
}

function inputsrequired() {
    $("body").on("blur", ".inputs", function (e) {
        // console.log(e.target.name);
        if (e.target.name == 'name') {
            var regu = /^[a-zA-Z\u4e00-\u9fa5]+$/;
            var re = new RegExp(regu);
            if (e.target.value.length > 0 && (re.test(e.target.value))) {
                e.target.nextElementSibling.setAttribute("src", "/imgs/pay/pay_detail/yes.png");
            } else {
                e.target.nextElementSibling.setAttribute("src", "/imgs/pay/pay_detail/no.png");
            }
        } else {
            if (e.target.value.length > 0) {
                e.target.nextElementSibling.setAttribute("src", "/imgs/pay/pay_detail/yes.png");
            } else {
                e.target.nextElementSibling.setAttribute("src", "/imgs/pay/pay_detail/no.png");
            }
        }
    });

    //验证姓名
    $("#certified_name").on('keyup focusout', function () {
        var name = $("#certified_name").val();
        var regu = /^[a-zA-Z\u4e00-\u9fa5]+$/;
        var re = new RegExp(regu);
        if (name != '' && (re.test(name))) {
            _certValidData.name = true;
        } else {
            _certValidData.name = false;
        }
    });

    //验证公司
    $("#certified_compony").on('keyup focusout', function () {
        var compony = $("#certified_compony").val();
        if (compony == 0) {
            _certValidData.compony = false;
        } else {
            _certValidData.compony = true;
        }
    });

    //验证职位
    $("#certified_position").on('keyup focusout', function () {
        var job = $("#certified_position").val();
        if (job == 0) {
            _certValidData.job = false;
        } else {
            _certValidData.job = true;
        }
    });


    // 邮箱验证
    $("#certified_email").on('keyup focusout', function () {
        var email = $("#certified_email").val();
        if (!validIsEmail(email)) {
            $("#certified_email").next().attr("src", "/imgs/pay/pay_detail/no.png");
            // showCheckedFailedIcon("cert_realemail_check");
            _certValidData.email = false;
        } else {
            $("#certified_email").next().attr("src", "/imgs/pay/pay_detail/yes.png");
            // showCheckedPassedIcon("cert_realemail_check");
            // $("#cert_realemail").removeClass("checked_failed_input");
            _certValidData.email = true;
        }
    });
    _certValidData.step = 2;
    // 点击下一步（数据验证及页面效果处理）
    $(".certified_btn_pay button").on("click", function () {
        _certValidData.step = 1;
        // console.log(validAllCertData(_certValidData));
        order_data.identity = $("#certIdentity_select").children('option:selected').attr("identity_id");
        if (!!order_data.identity) {
            _certValidData.identity = true
        }
        if (validAllCertData(_certValidData)) {
            $("#pay_content").show();
            $(".pay_certified").hide();
            $("tr .active:last").next().attr("class", "active");
            _certValidData.step = 2;
        } else {
            showValidNotPass(_certValidData);
        }

    });

    // 点击上一步
    $(".pay_footer .btn1").on("click", function () {
        _certValidData.step = 1;
        $("#pay_content").hide();
        $(".pay_certified").show();
        $("tr .active:last").removeAttr("class");

    });

    // 发票抬头验证
    $("#billname").on('keyup focusout', function () {
        var billname = $("#billname").val();
        if (billname == 0) {
            $("#billname").next().attr("src", "/imgs/pay/pay_detail/no.png");
            _certValidData.billname = false;
        } else {
            $("#billname").next().attr("src", "/imgs/pay/pay_detail/yes.png");
            _certValidData.billname = true;
        }
    });
    // 公司税号
    $("#billnumber").on('keyup focusout', function () {
        var billnumber = $("#billnumber").val();
        var reg_billnumber1 = /^[a-zA-Z0-9]{15}$/;
        var reg_billnumber2 = /^[a-zA-Z0-9]{18}$/;
        if (!((reg_billnumber1.test(billnumber)) || (reg_billnumber2.test(billnumber)))) {
            $("#billnumber").next().attr("src", "/imgs/pay/pay_detail/no.png");

            _certValidData.billnumber = false;
        } else {
            $("#billnumber").next().attr("src", "/imgs/pay/pay_detail/yes.png");

            _certValidData.billnumber = true;
        }
    });

    // 邮寄地址验证
    $("#billaddress").on('keyup focusout', function () {
        var billaddress = $("#billaddress").val();
        if (billaddress == 0) {
            _certValidData.billaddress = false;
        } else {
            _certValidData.billaddress = true;
        }
    });

    // 收件人验证
    $("#billpeople").on('keyup focusout', function () {
        var billpeople = $("#billpeople").val();
        if (billpeople == 0) {
            _certValidData.billpeople = false;
        } else {
            _certValidData.billpeople = true;
        }
    });

    // 联系方式验证
    $("#billphone").on('keyup focusout', function () {
        var billphone = $("#billphone").val();
        if (billphone == 0) {
            _certValidData.billphone = false;
        } else {
            _certValidData.billphone = true;
        }
    });

    var order_data = {};
    // 发起认证+付款请求
    $("#pc_pay").on("click", function () {
        order_data.identity = $("#certIdentity_select").children('option:selected').attr("identity_id");
        if (!!order_data.identity) {
            _certValidData.identity = true
        }

        if (validAllCertData(_certValidData)) {
            // $("tr .active:last").next().attr("class","active");

            if (_certValidData.checkbox) {
                order_data.suite_id = $(".pay_time .active").attr("data-id");
                order_data.is_invoice = 1;
                order_data.email = $("#certified_email").val();
                order_data.investor_name = $("#certified_name").val();
                order_data.com = $("#certified_compony").val();
                order_data.job = $("#certified_position").val();
                order_data.card = $("#upload_preview").attr("data-id");
                order_data.head = $("#billname").val();
                order_data.duty_sn = $("#billnumber").val();
                order_data.address = $("#billaddress").val();
                order_data.name = $("#billpeople").val();
                order_data.mobile = $("#billphone").val();
            } else {
                order_data.suite_id = $(".pay_time .active").attr("data-id");
                order_data.is_invoice = 0;
                order_data.investor_name = $("#certified_name").val();
                order_data.email = $("#certified_email").val();
                order_data.com = $("#certified_compony").val();
                order_data.job = $("#certified_position").val();
                order_data.card = $("#upload_preview").attr("data-id");
            }
            $.ajax({
                'url': v1url + "buy/create-order",
                'type': "POST",
                'headers': {
                    "token": PAY._token,
                    "devicetoken": cookie_PENCILNEWSID,
                },
                data: order_data,
                'success': function (data) {
                    if (data.code == -1) {
                        reLoginOnUc();
                        return;
                    } else if (data.code == 1000) {
                        // console.log(data);
                        $(".modal-body .body_tishi span").html("¥" + data.data.content.price);
                        $("#pay_modal").modal();
                        $("#qrcodeTable").html("");
                        jQuery('#qrcodeTable').qrcode({
                            width: 140,
                            height: 140,
                            text: Pc_Url + "pay_phone/" + "?token=" + PAY._token + "&id=" + data.data.content.id //根据此串生成第一个二维码  
                        });
                        is_pay(PAY._token, data.data.content.id);
                    } else if (data.code == 1002) {
                        showWarning("您的认证正在审核中，请耐心等待认证结果!");
                    } else if (data.code == 1003) {
                        showWarning(data.message);
                    } else if (data.code == 1005) {
                        showWarning(data.message);
                    } else {
                        showWarning(data.message)
                    }
                    // console.log(data);
                }
            })
        } else {
            showValidNotPass(_certValidData)
        }

    });

    // 已认证，发起付款请求
    $("#pc_pay2").on("click", function () {
        // console.log(_certValidData);
        // console.log(validAllCertData(_certValidData));
        order_data.identity = $("#certIdentity_select").children('option:selected').attr("identity_id");
        if (!!order_data.identity) {
            _certValidData.identity = true
        }

        if (validAllCertData(_certValidData)) {
            if (typeof ($(".pay_time .active").attr("data-id")) !== 'undefined') {
                if (_certValidData.checkbox) {
                    order_data.suite_id = $(".pay_time .active").attr("data-id");
                    order_data.is_invoice = 1;
                    order_data.head = $("#billname").val();
                    order_data.duty_sn = $("#billnumber").val();
                    order_data.address = $("#billaddress").val();
                    order_data.name = $("#billpeople").val();
                    order_data.mobile = $("#billphone").val();
                } else {
                    order_data.suite_id = $(".pay_time .active").attr("data-id");
                    order_data.is_invoice = 0;
                }
                clearInterval(timer);
                $.ajax({
                    'url': v1url + "buy/create-order",
                    'type': "POST",
                    'headers': {
                        "token": PAY._token,
                        "devicetoken": cookie_PENCILNEWSID,
                    },
                    data: order_data,
                    'success': function (data) {
                        if (data.code == -1) {
                            reLoginOnUc();
                            return;
                        }
                        if (data.code == 1000) {
                            // console.log("mydatas:", data);
                            $(".modal-body .body_tishi span").html("¥" + data.data.content.price);
                            $("#pay_modal").modal();
                            $("#qrcodeTable").html("");
                            jQuery('#qrcodeTable').qrcode({
                                width: 140,
                                height: 140,
                                text: Pc_Url + "pay_phone/" + "?token=" + PAY._token + "&id=" + data.data.content.id //根据此串生成第一个二维码  
                            });
                            is_pay(PAY._token, data.data.content.id);
                        } else {
                            showWarning(data.message)
                        }
                    },
                    'error': function (err) {
                        console.log(err);
                    }
                })
            } else {
                showWarning("请选择您需要订购的套餐！");
            }
        } else {
            showValidNotPass(_certValidData)
        }

    });

    // 确认付款
    $("#did_pay,#did_pay2").on("click", function () {
        // $("body").modal("show");
        if ($("#pay_modal").attr("data-investor") == -1) {
            if (timer == null) {
                $("#pay_modal2,#pay_modal").modal("hide");
                $("#pay_content").hide();
                $(".pay_wait").show();
                $("tr td").attr("class", "active");
                $("#buy_try").hide();
            } else {
                clearInterval(timer);
                $("#pay_modal").modal("hide");
                $("#pay_modal2 .head_tishi").html("后台暂无您的付款信息，请稍等再次点击“完成付款“");
                $("#did_pay2").html("确认");
                $("#pay_modal2").modal("show");

                $("#did_pay2").on("click", function () {
                    $("#pay_modal2,#pay_modal").modal("hide");
                });
            }

        } else {
            // window.location.href = Pc_Url + "projectlist";
            if (timer != null) {
                // console.log(timer)
                $("#pay_modal").modal("hide");
                $("#pay_modal2 .head_tishi").html("后台暂无您的付款信息，请稍等再次点击“完成付款“");
                $("#did_pay2").html("确认");
                $("#pay_modal2").modal("show");

                $("#did_pay2").on("click", function () {
                    $("#pay_modal2,#pay_modal").modal("hide");
                });
                clearInterval(timer);
            } else {
                // console.log("付款成功");
                window.location.href = Pc_Url + "projectlist";
            }
        }


    });

    //申请试用(未认证)
    $("#pc_try").on("click", function (e) {
        e.preventDefault();
        _certValidData.step = 1;
        order_data.identity = $("#certIdentity_select").children('option:selected').attr("identity_id");
        if (!!order_data.identity) {
            _certValidData.identity = true
        }
        if (validAllCertData(_certValidData)) {
            order_data.investor_name = $("#certified_name").val();
            order_data.email = $("#certified_email").val();
            order_data.com = $("#certified_compony").val();
            order_data.job = $("#certified_position").val();
            order_data.card = $("#upload_preview").attr("data-id");
            _certValidData.step = 2;
            $.ajax({
                'url': v1url + 'buy/create-order?ontrial=1',
                'type': 'POST',
                'headers': {
                    'token': PAY._token,
                },
                'data': order_data,
                'success': function (data) {
                    if (data.code === 1000) {
                        $("#try_modal").modal()
                    } else {
                        showWarning(data.message)
                    }

                }
            })
        } else {
            showValidNotPass(_certValidData)
        }


    })

    //申请试用（已认证）
    $("#pc_try2").on("click", function (e) {
        e.preventDefault();
        // console.log("qqqqqq");
        // order_data.email = $("#certified_email").val();
        // order_data.com = $("#certified_compony").val();
        // order_data.job = $("#certified_position").val();
        // order_data.card = _certValidData.hash4;
        // console.log('try2');
        $.ajax({
            'url': v1url + 'buy/create-order?ontrial=1',
            'type': 'POST',
            'headers': {
                'token': PAY._token,
            },
            'success': function (data) {
                // console.log(data)
                if (data.code === 1000) {
                    $("#try_modal2").modal()
                } else {
                    showWarning(data.message)
                }
            }
        })

    })

    //弹框消失时对定时器进行清除
    $('#pay_modal').on('hide.bs.modal', function () {
        clearInterval(timer);
    })

    // 付费轮询，检查是否完成付款
    var timer = null;

    function is_pay(token, order_id) {
        timer = setInterval(function () {
            $.ajax({
                "url": v1url + "pay/get-order",
                "type": "GET",
                'headers': {
                    "token": token,
                },
                "data": {
                    "id": order_id,
                },
                "success": function (data) {
                    // console.log("付费轮询", data);
                    if (data.data.order.pay_status == 1) {
                        $("#pay_modal").modal("hide");
                        $("#pay_modal2 .head_tishi").html("付费成功，请点击完成付款进入下一步");
                        $("#pay_modal2").modal();
                        clearInterval(timer);
                        timer = null;
                    } else {
                        // $("#pay_modal").modal("hide");
                        // $("#pay_modal2 .head_tishi").html("后台暂无您的付款信息，请稍等再次点击“完成付款“");
                        // $("#pay_modal2").modal();
                    }
                }
            })
        }, 1000);
    }

    // 数据验证
    function validAllCertData(certValidData) {
        if (_certValidData.step == 1) {
            return (certValidData.name && certValidData.identity && certValidData.compony && certValidData.job && certValidData.email && _certValidData.picHash);
        } else if (_certValidData.checkbox) {
            return (certValidData.billname && certValidData.billnumber && certValidData.billaddress && certValidData.billpeople && certValidData.billphone);
        } else {
            return true;
        }
    }

    // 对未通过相加红色边框提醒
    function showValidNotPass(certValidData) {
        var regu = /^[a-zA-Z\u4e00-\u9fa5]+$/;
        var re = new RegExp(regu);
        if (certValidData.step == 1) {
            if (!certValidData.name) {
                $("#certified_name").parent().addClass("checked_failed_input")
            } else {
                $("#certified_name").parent().removeClass("checked_failed_input")
            }
            if (!certValidData.compony) {
                $("#certified_compony").parent().addClass("checked_failed_input")
            } else {
                $("#certified_compony").parent().removeClass("checked_failed_input")
            }
            if (!certValidData.job) {
                $("#certified_position").parent().addClass("checked_failed_input")
            } else {
                $("#certified_position").parent().removeClass("checked_failed_input")
            }
            if (!certValidData.email) {
                $("#certified_email").parent().addClass("checked_failed_input")
            } else {
                $("#certified_email").parent().removeClass("checked_failed_input")
            }
            if (!certValidData.picHash) {
                $("#card-preview").addClass("checked_failed_input")
            } else {
                $("#card-preview").removeClass("checked_failed_input")
            }
            // 弹出提示框
            if (!certValidData.name) {
                showWarning("真实姓名只能为汉字或英文字母!");
                return;
            } else if (!certValidData.identity) {
                showWarning("请选择您想要认证的身份类型！");
                return;
            } else if (!certValidData.compony) {
                $("#certified_compony").parent().addClass("checked_failed_input")
                showWarning("请填写所在公司！");
                return;
            } else if (!certValidData.job) {
                showWarning("请填写所在公司职位！");
                return;
            } else if (!certValidData.email) {
                showWarning("请填写您的电子邮箱！");
                return;
            } else if (!certValidData.picHash) {
                showWarning("请提交您的名片！");
                return;
            } else {
                return;
            }
        }

        // 是否需要发票，需要者验证表单
        if (_certValidData.checkbox) {
            if (!certValidData.billname) {
                $("#billname").parent().addClass("checked_failed_input");
            } else {
                $("#billname").parent().removeClass("checked_failed_input");
            }
            if (!certValidData.billnumber) {
                $("#billnumber").parent().addClass("checked_failed_input");
            } else {
                $("#billnumber").parent().removeClass("checked_failed_input");
            }
            if (!certValidData.billaddress) {
                $("#billaddress").parent().addClass("checked_failed_input");
            } else {
                $("#billaddress").parent().removeClass("checked_failed_input");
            }
            if (!certValidData.billpeople) {
                $("#billpeople").parent().addClass("checked_failed_input");
            } else {
                $("#billpeople").parent().removeClass("checked_failed_input");
            }
            if (!certValidData.billphone) {
                $("#billphone").parent().addClass("checked_failed_input");
            } else {
                $("#billphone").parent().removeClass("checked_failed_input");
            }

            // 弹出提示框
            if (!certValidData.billname) {
                showWarning("请填写个人或公司完整名称！");
                return;
            } else if (!certValidData.billnumber) {
                showWarning("请填写正确的税号！");
                return;
            } else if (!certValidData.billaddress) {
                showWarning("请输入您想要收到发票的地址！");
                return;
            } else if (!certValidData.billpeople) {
                showWarning("请输入收件人的姓名！");
                return;
            } else if (!certValidData.billphone) {
                showWarning("请输入收件人的联系电话！");
                return;
            } else {
                return;
            }
        }
    }
}